<template>
    <div class="contact-info">
        <div class="contact-info-header">
            <div class="credentials">
                <h5 class="label">{{ $t('magazine.contact_person') }}</h5>
                <div class="name">{{ contact }}</div>
            </div>
            <b-button
                class="btn-link-type btn-edit-magazine-contact"
                v-b-modal="'set-contact-modal'"
                variant="primary">
                {{ $t('common.edit') }}
            </b-button>
        </div>
        <b-modal
            :id="'set-contact-modal'"
            :ref="'set-contact-modal'"
            :title="$t('magazine.set_contact_person')"
            :ok-title="$t('common.close')"
            ok-only
            modal-class="apprentice-default-modal">
            <v-server-table
                ref="table"
                :columns="accountsTableColumns"
                :options="accountsTableOptions"
                name="magazine-contacts-table">
                <div
                    slot="actions"
                    slot-scope="{ row }">
                    <b-button
                        class="btn-hand-pointer btn-choose-user"
                        variant="primary-icon-only"
                        :title="$t('common.choose')"
                        @click="onSelect(row.id)"></b-button>
                </div>
            </v-server-table>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-contact-component',
    props: ['magazineIn'],
    data() {
        return {
            contact: this.magazineIn.contact
                ? this.magazineIn.contact.full_name + ' (' + this.magazineIn.contact.email + ')'
                : this.$t('magazine.unfamiliar'),
            accountsTableColumns: ['full_name', 'email', 'actions'],
            accountsTableOptions: {
                headings: {
                    full_name: this.$t('common.name'),
                    email: this.$t('common.email'),
                    actions: this.$t('common.actions'),
                },
                sortIcon: {
                    base: 'fad',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                sortable: ['full_name', 'email'],
                filterable: ['full_name', 'email'],
                saveState: true,
                requestFunction(data) {
                    if (data.orderBy) {
                        switch (data.orderBy) {
                            case 'type_name':
                                data.orderBy = 'type';
                                break;
                            case 'full_name':
                                data.orderBy = 'surname';
                                break;
                        }
                    }

                    return this.axios.get(this.routes.schoolGetAccounts(), { params: data });
                },
                filterAlgorithm: {
                    full_name(row, query) {
                        return row.preposition.length
                            ? (row.name + ' ' + row.preposition + ' ' + row.surname).includes(query)
                            : (row.first_name + ' ' + row.surname).includes(query);
                    },
                },
            },
        };
    },
    methods: {
        onSelect(id) {
            this.alert.saving();

            const data = {
                user_id: id,
            };

            this.axios.post(this.routes.magazine(this.magazineIn.id) + '/contact', data).then(
                (response) => {
                    this.contact = response.data.user.full_name + ' (' + response.data.user.email + ')';
                    this.alert.success();
                    this.$refs['set-contact-modal'].hide();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.contact-info {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    padding-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    border-bottom: 3px dotted $border-color;
    height: auto;

    .contact-info-header {
        display: flex;
        justify-content: space-between;

        .btn-edit-magazine-contact {
            align-self: baseline;
        }
    }

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .name {
        color: $primary;
    }
}
</style>
